.upiAttributes {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}

.input {
  width: 18rem;
}

.button {
  margin-top: 2rem;
}
